import React from "react";
import { StyleSheet, View } from "react-native";
import {
  cleanInput,
  validateAlphabheticEntry,
  isValidName
} from "screens/LoginRegistration/utils";
import { Colors } from "styled42/config";
import STextField from "styled42/components/STextField";
import SText from "styled42/components/SText";
import VernacManager from "utils/vernacular";

const Label = (props) => {
  return (
    <SText>
      {VernacManager.translateString("create_account_enter_your")}
      <SText style={{ fontWeight: "bold", marginLeft: 4 }}>
        {" "}
        {VernacManager.translateString("create_account_full_name")}
      </SText>
    </SText>
  );
};

const NameComponent = ({ value, handleStateChange }) => {
  return (
    <STextField
      autoFocus
      label={<Label />}
      // labelStyle={styles.inputLabel}
      inputStyle={{
        backgroundColor: "white",
        height: "100%",
        textAlignVertical: "center"
      }}
      placeholder="eg Rakesh Sharma"
      placeholderTextColor={Colors.Grey[5]}
      value={value}
      onChangeText={(input) => {
        let isAlphabetic = false;
        isAlphabetic = validateAlphabheticEntry(cleanInput("name", input));
        if (isAlphabetic) {
          handleStateChange({
            component: "fullName",
            value: input
          });
        }
      }}
    />
  );
};

export default NameComponent;
